"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_PRODUCT_TYPE = void 0;
exports.EMPTY_PRODUCT_TYPE = {
    id: 'others',
    name: 'Others',
};
//# sourceMappingURL=productType.js.map